import errors from './errors'
import flash from './flash'
import form from './form'
import help from './help'

export default {
  actions: 'actions',
  add: 'ajouter',
  admin: 'administrateur',
  askResetPassword: 'Demander le renouvellement de votre mot de passe',
  author: 'auteur',
  authorAdd: '@:add un @:author',
  authorList: 'liste des @:authors',
  authorEmptyList: 'Aucun auteur à afficher',
  authorListEmpty: 'Il n\'y a pas encore d\'@:authors',
  authorUpdate: '@:update un @:author',
  authors: '@:(author)s',
  banner: 'Bandeau',
  block: 'bloc',
  blockAdd: 'Ajouter un @:block',
  blockEditing: 'Éditer un @:block',
  blockListEmpty: 'Il n\'y a pas encore de @:blocks',
  blocks: '@:(block)s',
  book: 'livre',
  bookAdd: '@:add un @:book',
  bookAuthors: '@:authors du @:book',
  bookContentAdd: '@:add un contenu',
  bookContentListEmpty: 'Il n\'y a pas encore de contenus supplémentaires',
  bookContentEmptyList: 'Aucun contenu à afficher',
  bookContents: 'contenus supplémentaires',
  bookDelete: '@:delete le @:book',
  bookDetails: 'détails du @:book',
  bookDraftUpdate: '@:update le brouillon d\'un @:book',
  bookDraftList: 'liste des brouillons de @:books',
  bookDraftListEmpty: 'Il n\'y a pas de brouillons de @:book',
  bookEmptyList: 'Aucun @:book à afficher',
  bookList: 'liste des @:books',
  bookListEmpty: 'Il n\'y a pas encore de @:books',
  bookNotFound: 'Aucun @:book n\'existe sous ce nom',
  bookSubmit: 'ajouter le @:book',
  tagHandle: 'Gérer les tags',
  bookTagAdd: '@:add un @:tag',
  bookTagEmptyList: 'Aucun @:tag à afficher',
  bookTagUpdate: '@:update un @:tag',
  bookTags: 'Tags de @:book',
  bookTagList: 'liste des @:tags',
  bookTagListEmpty: 'Il n\'y a pas de @:tags',
  bookUpdate: '@:update un @:book',
  books: '@:(book)s',
  carousel: 'Carousel d\'images',
  changePassword: 'Modification du mot de passe',
  chooseOption: 'Choisir une option',
  collection: 'collection',
  collectionAdd: '@:add une collection',
  collectionChoose: 'Choisir une @:collection',
  collectionList: 'liste des @:(collections)',
  collectionEmptyList: 'Aucune collection à afficher',
  collectionListEmpty: 'Il n\'y a pas encore de @:collections',
  collectionNotFound: 'Aucune collection n\'existe sous ce nom',
  collectionUpdate: '@:update une @:collection',
  collections: '@:(collection)s',
  configuration: 'configuration',
  configurationUpdate: '@:update la @:configuration du site publique',
  cover: 'Couverture',
  dashboard: 'tableau de bord',
  dragAuthorsHere: 'glissez les auteurs ici',
  draft: 'brouillon',
  drafts: '@:(draft)s',
  draftList: 'liste des @:drafts',
  draftsExist: 'Par contre il y a des @:drafts',
  delete: 'supprimer',
  cancel: 'Annuler',
  cancelBeforeSaving: 'Vous n\'avez pas sauvegardé les modifications, voulez-vous vraiment annuler ?',
  center: 'Centrer',
  confirm: 'confirmer',
  confirmDelete: 'confirmer la suppression',
  content: 'contenu',
  contents: '@:(content)s',
  deleteUser: 'supprimer l\'@:user {username}',
  deleteModel: 'êtes-vous sûr de vouloir supprimer ceci ?',
  deleteCollection: 'supprimer la @:collection {title}',
  details: 'détails',
  display: 'affichage',
  editBook: 'modifier un @:book',
  editProfile: 'éditer votre compte',
  enabled: 'activé',
  error: 'Une erreur est survenue',
  error400: {
    passwordResetRequest: 'L\'email donné n\'existe pas',
    passwordReset: '@:error'
  },
  error401: {
    login: 'Identifiants invalides, merci de réessayer !'
  },
  error404: 'Erreur 404',
  errors,
  fileAdd: 'Ajouter un fichier',
  fileName: 'Nom du fichier',
  filter: 'Filtrer',
  firstName: 'Prénom',
  flash,
  forbidden: 'Interdit',
  forgottenPassword: 'Vous avez oublié quelque chose ?',
  form,
  fullName: 'nom',
  fullWidth: 'Largeur complète',
  go_to_site: 'Voir le site',
  hello_username: 'Bonjour {username}',
  help,
  hidePreview: 'Masquer l\'aperçu',
  icon: 'icon',
  iconChoose: 'Choisir un icon',
  iframeBlock: 'Media externe',
  iframePreview: 'Aperçu du media externe:',
  iframeSourceEmpty: 'Définissez une url pour le media externe',
  iframeUrlOrBlock: 'Balise "iframe" ou url du media externe',
  image: 'image',
  imageListEmpty: 'Il n\'y a pas encore d\'images',
  images: '@:(image)s',
  imagesBlock: 'Images',
  imagesGallery: 'Galerie d\'@:images',
  imageType: 'Type d\'image',
  imageAdd: 'Ajouter une image',
  importantColor: 'Couleur importante',
  infos: 'informations',
  isShown: 'Affiché',
  itsTimeToWork: 'Il est temps de se mettre au boulot !',
  justifiedGrid: 'Grille justifiée',
  justifiedLeft: 'Justifié à gauche',
  justifiedRight: 'Justifié à droite',
  lastLogin: 'dernière connexion',
  lastName: 'Nom',
  lastUpdate: 'dernière mise à jour à',
  left: 'Gauche',
  linkAdd: 'Ajouter un lien',
  logo: 'Logo',
  login: 'Se connecter',
  log_out: 'se déconnecter',
  menu: 'menu',
  menuAdd: '@:add un @:menu',
  menuDelete: '@:delete le @:menu',
  menuEmptyList: 'Aucun @:menu à afficher',
  menuList: 'liste des @:menus',
  menuListEmpty: 'Il n\'y a pas encore de @:menus',
  menuNotFound: 'Le @:menu que vous cherchez n\'existe pas.',
  menus: '@:(menu)s',
  menuDetails: 'détails du @:menu',
  menuSubmit: 'ajouter le @:menu',
  menuUpdate: '@:update un @:menu',
  moderator: 'modérateur',
  name: 'nom',
  nameAdd: 'Ajouter un @:name',
  newUser: 'Nouvel @:user',
  newAuthor: 'Nouvel @:author',
  newBook: 'Nouveau @:book',
  newBlock: 'Nouveau @:block',
  newCollection: 'Nouvelle @:collection',
  nextStep: 'étape suivante',
  noFileAdded: 'Aucun fichier ajouté',
  noResults: 'aucun résultat',
  noSelection: 'Aucune sélection',
  on: 'le',
  page: 'page',
  pageAdd: '@:add une @:page',
  pageChoose: 'Choisir une @:page',
  pageContentAdd: '@:add un @:content',
  pageContentEmptyList: 'Aucune @:page à afficher',
  pageContentListEmpty: 'Il n\'y a pas encore de @:content supplémentaire',
  pageContents: '@:contents supplémentaires',
  pageDelete: '@:delete la @:page',
  pageDraftUpdate: '@:update le @:draft d\'une @:page',
  pageDraftList: 'liste des @:drafts de @:pages',
  pageDraftListEmpty: 'Il n\'y a pas de brouillons de @:page',
  pageEmptyList: 'Aucune @:page à afficher',
  pageList: 'liste des @:pages',
  pageListEmpty: 'Il n\'y a pas encore de @:pages',
  pageNotFound: 'La page que vous cherchez n\'existe pas.',
  pages: '@:(page)s',
  pageDetails: 'détails de la @:page',
  pageSubmit: 'ajouter la @:page',
  pageUpdate: '@:update une @:page',
  password: 'Mot de passe',
  passwordResetRequested: 'Un email vous permettant de modifier votre mot de passe a été envoyé',
  passwordReset: 'Le mot de passe a bien été mis à jour',
  path: 'chemin d\'accès',
  post: 'actualité',
  postAdd: '@:add une @:post',
  postBooks: 'Livres associés',
  postDateAdd: 'Ajouter une date à l\'actualité',
  postDates: 'Dates de l\'actualité',
  postList: 'liste des @:posts',
  postEmptyList: 'Aucune actualité à afficher',
  postListEmpty: 'Il n\'y a pas encore d\'@:posts',
  postNotFound: 'Aucune @:post n\'existe sous ce nom',
  postTypeAdd: 'Ajouter un type d\'actualité',
  postTypeAlreadyExists: 'Le type d\'actualité existe déjà',
  postTypeEmptyList: 'Aucun type d\'actualité à afficher',
  postTypeListEmpty: 'Il n\'y a pas encore de types d\'actualité',
  postTypeUpdate: '@:update un type d\'actualité',
  postType: 'type d\'actualité',
  postTypes: 'types d\'actualité',
  postTypesHandle: 'Gérer les types d\'actualité',
  postTypesList: 'liste des types d\'actualité',
  postUpdate: '@:update une @:post',
  posts: '@:(post)s',
  postVenue: 'Lieu de l\'actualité',
  primaryColor: 'Couleur primaire',
  profile: 'votre compte',
  profileDetails: 'Détails du compte',
  profileEdit: 'édition du compte',
  profilePassword: 'Mots de passe',
  profileSettings: 'paramètres du compte',
  profileShow: 'voir votre compte',
  publishDate: 'Date de publication',
  quitBeforeSaving: 'Vous n\'avez pas sauvegardé, voulez-vous vraiment quitter la page ?',
  reducedWidth: 'Largeur réduite',
  releaseDate: 'date de sortie',
  return: 'Retour',
  returnToBook: 'Retourner au @:book',
  returnToBookList: '@:returnToList des @:books',
  returnToCollectionList: '@:returnToList des @:collections',
  returnToContentList: '@:returnToList des @:contents',
  returnToDraftList: '@:returnToList des @:drafts',
  returnToIndex: 'Retourner à l\'accueil',
  returnToList: 'Retourner à la liste',
  returnToMenuList: '@:returnToList des @:menus',
  returnToPageList: '@:returnToList des @:pages',
  returnToPostList: '@:returnToList des @:posts',
  returnToPostTypeList: '@:returnToList des @:postTypes',
  returnToTagList: '@:returnToList des @:tags',
  reset: 'restaurer',
  resource: 'ressource',
  resourceAdd: '@:add une @:resource',
  resourceListEmpty: 'Il n\'y a pas encore de @:resource',
  resources: '@:(resource)s',
  resourcesBlock: 'Bloc de resources',
  right: 'Droite',
  ROLE_ADMIN: '@:admin',
  ROLE_MODERATOR: '@:moderator',
  ROLE_USER: '@:user',
  save: 'enregistrer',
  secondaryColor: 'Couleur secondaire',
  seeDrafts: 'voir les brouillons',
  selectBlockAlignment: 'Choisir l\'alignement du bloc',
  selectBlockType: 'Choisir le type du bloc',
  selectBlockWidth: 'Choisir la largeur du bloc',
  showPreview: 'Voir l\'aperçu',
  singleImage: 'Image seule',
  submit: 'valider',
  super_admin: 'super @:admin',
  tag: 'tag',
  tags: 'tags',
  tagAdd: '@:add un @:tag',
  text: 'Texte',
  textBlock: 'Bloc de texte',
  title: 'titre',
  titles: 'titres',
  type: 'Type',
  unauthorized: 'Vous n\'êtes pas autorisé à être ici !',
  updatedAt: 'modifié le',
  updatePassword: 'Mettre à jour votre mot de passe',
  update: 'modifier',
  user: 'utilisateur',
  userAdd: '@:add un @:user',
  userUpdate: '@:update un @:user',
  userNotFound: 'Aucun utilisateur n\'existe sous ce nom',
  users: '@:(user)s',
  userList: 'liste des @:users',
  userListEmpty: 'il n\'y a pas encore d\'@:users',
  validate: 'valider',
  venue: 'Lieu',
  welcome: 'Bienvenue',
  width: 'Largeur',
  writeSomething: 'Écrivez quelque chose !',
  youAreNotAlone: 'Vous n\'êtes pas tout seul !'
}
